import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { ensureHomeData } from './feature-access';

export const alarmGuard: CanActivateFn = async () => {
  const router = inject(Router);
  const homeData = await ensureHomeData();

  if (homeData?.hasAlarmModuleAccess === true) {
    return true;
  }

  return router.parseUrl('/home');
};
